import Button from '@/components/ui/button/Button'
import React, { FC, useEffect, useRef, useState } from 'react'
import style from './GetOfferSearchBox.module.scss'
import { MdKeyboardArrowDown } from 'react-icons/md'
import { ApiData } from '@/api/apiData/api.data'
import { PropsGetOfferSearchBox } from './PropsGetOfferSearchBox'
import exitSvg from '@/assets/images/arrowExit.svg'
import { useTranslation } from 'react-i18next'

const GetOfferSearchBox: FC<PropsGetOfferSearchBox> = ({
	state,
	handleClick,
	setError
}) => {
	const { t } = useTranslation()
	const [isOpenBox, setIsOpenBox] = useState(false)
	const modalRef = useRef(null)
	const [btnText, setBtnText] = useState(t('choose_direction'))
	const selectedCountries = state.countryCode
		.split(',')
		.map(item => item.trim())
		.filter(Boolean)

	useEffect(() => {
		setBtnText(state.countryCode || t('choose_direction'))
	}, [state.countryCode, t])

	React.useEffect(() => {
		let handler = (e: any) => {
			//@ts-ignore
			if (!modalRef.current?.contains(e.target)) {
				setIsOpenBox(false)
			}
		}

		document.addEventListener('mousedown', handler)
		return () => {
			document.removeEventListener('mousedown', handler)
		}
	}, [])
	const handlerClick = (
		e: React.MouseEvent<HTMLButtonElement, MouseEvent>
	) => {
		setIsOpenBox(!isOpenBox)
		e.stopPropagation()
	}

	return (
		<div className={style.getOfferSearchBox}>
			<div ref={modalRef} className={style.class}>
				<Button
					className={style.button}
					classDiv={style.div}
					onClick={e => {
						setError(false)
						handlerClick(e)
					}}
				>
					<div className={style.itemTable}>
						{btnText}
						{/* t(RevertCountryCode(state.countryCode)) ||
							t('choose_direction') */}
						<MdKeyboardArrowDown />
					</div>
				</Button>
				{isOpenBox && (
					<ul className={style.table}>
						{ApiData.directionsData2GetOffer.map((el, key) => {
							const countryName = t(el.name)
							const isChecked =
								selectedCountries.includes(countryName)
							return (
								<li key={key} className={style.itemRow}>
								<label
									className={`${style.itemLabel} ${
										isChecked &&
										style.active
									}`}
								>
									<input
										type='checkbox'
										checked={isChecked}
										onChange={() => {
											handleClick(el.code)
										}}
									/>
									<span>{t(el.name)}</span>
								</label>
								</li>
							)
						})}
						<div
							className={style.exit}
							onClick={() => setIsOpenBox(false)}
						>
							<img src={exitSvg} alt='arrow-exit' />
						</div>
					</ul>
				)}
			</div>
		</div>
	)
}
export default GetOfferSearchBox
